import { MessageItem } from 'semantic-ui-react'

const ListItem = ({ children }) => {
    return (
      <MessageItem>
          {children}
      </MessageItem>
    )
}

export { ListItem }
